import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-todolist",
  "use": "icon-todolist-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-todolist\"><path d=\"M606 671.5H307.7v75.2H606v-75.2z m0-163.1H307.7v75.2H606v-75.2zM493.5 347.1H307.7v75.2h185.8v-75.2z m50.7-150.7H182.1v687.7h549.4V534.4h75.2v360.8c-0.1 35.4-28.9 64.1-64.3 64H171.2c-35.4 0-64.1-28.7-64.2-64.1V185.4c0-35.4 28.8-64.1 64.2-64.1h373v75.1z m368.5 17.9L800.4 101.4c-2.8-3.8-7.5-5.5-12.1-4.5s-8.1 4.6-9.1 9.1l-15.3 41.3c-5.1 11.8-13.9 21.7-25 28.2l-142.5 73.8c-4.5 1.8-7.7 5.9-8.5 10.7-0.8 4.8 1.1 9.7 4.8 12.8l51 51.3L560 444.4 683.3 364l58.6 58.9c3.2 3.8 8.1 5.6 13 5 4.9-0.7 9.1-3.8 11.2-8.2l78.3-137.9c7-11 16.6-20.1 28-26.5l36.4-17.9c4.5-1.7 7.8-5.7 8.6-10.4 0.8-4.9-1-9.7-4.7-12.7z m0 0\" p-id=\"15099\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/todolist.svg
// module id = cR6r
// module chunks = 250